<template>
  <div v-if="isShow" class="loading">
    <div class="loading-body">
      <div class="ani"></div>
      {{ text }}
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isShow: false,
      text: "加载中...",
    };
  },
  methods: {
    show(text) {
      this.isShow = true;
      this.text = text || this.text;
    },
    hide() {
      this.isShow = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.loading {
  position: fixed;
  z-index: 9999;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  .loading-body {
    flex-direction: column;
    display: flex;
    gap: 0.5rem;
    color: white;
    padding: 0.8rem;
    border-radius: 0.2rem;
    background: rgba(0, 0, 0, 0.5);
    align-items: center;
    .ani {
      width: 1.5rem;
      aspect-ratio: 1;
      border-radius: 50%;
      background: radial-gradient(farthest-side, white 94%, #0000) top/0.3rem
          0.3rem no-repeat,
        conic-gradient(#0000 30%, white);
      -webkit-mask: radial-gradient(
        farthest-side,
        #0000 calc(100% - 0.3rem),
        #000 0
      );
      animation: l13 1s infinite linear;
    }
  }
}
@keyframes l13 {
  100% {
    transform: rotate(1turn);
  }
}
</style>
